import CatalogSearchStore, {
    SEARCH_CATALOG_WORK_OPTIONS,
    defaultCatalogSelectionCriteria,
} from '@App/stores/search/work/catalog-search-store'
import { PaginationBody } from '@Entities/pagination'
import { WorkSearch } from '@App/stores/search/models/work-search'
import { searchWorks } from '@App/api/routes/search'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import { Works } from '@Entities/work/works'

const TRANSFER_CATALOG_WORK_OPTIONS = SEARCH_CATALOG_WORK_OPTIONS.filter(({ value }) => value !== 'memberProprietaryId')

export class TransferCatalogSearchStore extends CatalogSearchStore {
    public resetSearchCriteriaStore() {
        const maxCriteria = 8
        this.searchCriteriaStore = new SearchCriteriaStore(
            defaultCatalogSelectionCriteria,
            TRANSFER_CATALOG_WORK_OPTIONS,
            SearchOptionType.primary,
            RequiredCriteria.primaryFilter,
            maxCriteria,
            ['MLC_OVERCLAIM', 'MLC_DISPUTE']
        )
    }

    public async fetchWorks(pagination: PaginationBody, search?: WorkSearch): Promise<Works> {
        const sourcePublisherNumbers = this.rootStore.catalogTransferWizardStore.sourcePublishers
            .map((publisher) => publisher.hfaPublisherNumber)
            .filter((number): number is string => !!number)
        if (!sourcePublisherNumbers?.length) {
            throw new Error('sourcePublisherNumbers are missing')
        }
        const searchQuery: WorkSearch = {
            ...search,
            bothPublisherNumbers: sourcePublisherNumbers,
        }
        // TODO - can we expand searchWorksForPublisher to include additional criteria?
        const response = await searchWorks(pagination, searchQuery)

        return {
            count: response.data.totalElements,
            works: response.data.content,
            error: undefined,
        }
    }

    protected loadRelatedData(): void {
        // Catalog transfer results do not display rightsholder claimed shares.
    }

    get searchScopeKey(): unknown[] {
        return [
            'transfer-catalog',
            this.rootStore.catalogTransferWizardStore.sourcePublishers.map((publisher) => publisher.hfaPublisherNumber),
        ]
    }
}
